import { MenuCategoryCreateDto, MenuCategoryUpdateDto } from "../../../api";
import MenuCategoryModalForm from "../menuCategoryModalForm/menuCategoryModalForm";

export default function MenuCategoryModalFormAddContainer(props: MenuCategoryModalFormAddContainerProps) {
    return <>
        <MenuCategoryModalForm
            isModalVisible={props.addFormVisibility}
            setModalVisibility={props.onFinish}
            onSubmit={props.onSubmit}
            modalTitle={props.title}
            saveButtonTitle="Zapisz"
            cancelButtonTitle="Anuluj"
            initialValues={props.MenuCategoryToEdit!}
        />
    </>
}

interface MenuCategoryModalFormAddContainerProps {
    onFinish: (refreshList: boolean) => void,
    onSubmit: (values: MenuCategoryCreateDto | MenuCategoryUpdateDto) => Promise<any>,
    addFormVisibility: boolean,
    title: string,
    MenuCategoryToEdit: MenuCategoryUpdateDto | null
}
